import type { Action } from "../../actions/types";

export type StoreState = boolean;

export const initialState = false;

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState | null {
  if (action.type === "GET_MEMBER_TIER_CUSTOMER_REQUEST") {
    return true;
  }

  if (
    action.type === "GET_MEMBER_TIER_CUSTOMER_SUCCESS" ||
    action.type === "GET_MEMBER_TIER_CUSTOMER_FAILURE"
  ) {
    return false;
  }

  return state;
}
